/* Who may sign in for a partner or customer. Invites are claimed at first ScaiKey login with the same verified e-mail. */
import { For, Show, createResource, createSignal } from 'solid-js';
import { api } from '../api';
import { ErrorLine, StatusPill, useAction } from '../ui';

type Binding = { id: string; role: string; sub: string | null; email: string | null; pending: boolean };
const label: Record<string, string> = { partner_admin: 'Partner admin', customer_admin: 'Admin', customer_staff: 'Staff' };

export default function Users(props: { scope: { partner_id?: string; customer_id?: string }; roles: string[] }) {
  const qs = () => new URLSearchParams(props.scope as Record<string, string>).toString();
  const [rows, { refetch }] = createResource(qs, (q) => api<Binding[]>(`/bindings?${q}`));
  const [email, setEmail] = createSignal('');
  const [role, setRole] = createSignal(props.roles[0]);
  const [resent, setResent] = createSignal<string | null>(null);
  const a = useAction();

  const invite = (e: Event) => {
    e.preventDefault();
    a.run(async () => {
      await api('/bindings', { method: 'POST', json: { role: role(), email: email(), ...props.scope } });
      setEmail(''); refetch();
    });
  };

  return (
    <div class="flex flex-col gap-3 py-2">
      <ul class="flex flex-col gap-1">
        <For each={rows()} fallback={<li class="text-sm text-ink-3">Nobody yet.</li>}>
          {(b) => (
            <li class="flex items-center gap-3 text-sm">
              <span class="font-semibold">{b.email ?? b.sub}</span>
              <span class="text-ink-3">{label[b.role] ?? b.role}</span>
              <Show when={b.pending}><StatusPill tone="warn">invited</StatusPill></Show>
              <Show when={b.pending}>
                <button class="btn btn-ghost btn-xs ml-auto" disabled={resent() === b.id}
                  onClick={() => a.run(async () => { await api(`/bindings/${b.id}/resend`, { method: 'POST' }); setResent(b.id); })}>
                  {resent() === b.id ? 'Mail sent' : 'Resend invite'}
                </button>
              </Show>
              <button class={`btn btn-ghost btn-xs ${b.pending ? '' : 'ml-auto'}`} onClick={() => a.run(async () => { await api(`/bindings/${b.id}`, { method: 'DELETE' }); refetch(); })}>Remove</button>
            </li>
          )}
        </For>
      </ul>
      <form class="flex flex-wrap items-end gap-2" onSubmit={invite}>
        <input type="email" required placeholder="name@company.com" class="input input-sm input-bordered" value={email()}
          onInput={(e) => setEmail(e.currentTarget.value)} aria-label="E-mail address" />
        <Show when={props.roles.length > 1}>
          <select class="select select-sm select-bordered" value={role()} onChange={(e) => setRole(e.currentTarget.value)} aria-label="Role">
            <For each={props.roles}>{(r) => <option value={r}>{label[r]}</option>}</For>
          </select>
        </Show>
        <button class="btn btn-sm btn-secondary" disabled={a.busy()}>Invite</button>
      </form>
      <p class="text-xs text-ink-3">We e-mail an invitation. An address without a sign-in account gets one, with a separate mail to set its password (link valid for an hour); "Resend invite" sends a fresh link until they have.</p>
      <ErrorLine error={a.error} />
    </div>
  );
}
